/*
 * @Description: 
 * @Author: xutao
 * @Date: 2020-11-13 14:20:25
 * @LastEditors: xutao
 * @LastEditTime: 2021-02-02 17:26:02
 */
/* eslint-disable import/no-mutable-exports */
const { hostname } = window.location
const y = hostname.split('.')[0]
let config = null
if (y === 'st') { // 测试环境 压测
  config = {
    dataBasePath: 'st.yunjiglobal.com',
    AWSC: 'buy-al-st.yunjiglobal.com',
    userPath: 'st.yunjiglobal.com',
    spePath: 'special-al-dev.yunjiglobal.com',
    servicePath: '//t-do-dev.yunjiglobal.com/xinyunpage/',
    h5CacheList: '//static.yunjiglobal.com/qnUpload/frontend/config/h5CacheListTest.json',
    environment: 'stresstest',
    yunjibuyerPath: 't-do-dev.yunjiglobal.com'
  }
} else if (y === 't-do-dev' || y === 'm-do-dev' || y === 'special-al-dev-tmp' || y === 'special-al-dev' || y === 'spe-do-dev') { // docker 环境
  config = {
    dataBasePath: 't-do-dev.yunjiglobal.com',
    AWSC: 'buy-do-dev.yunjiglobal.com',
    userPath: 'user-do-dev.yunjiglobal.com',
    spePath: 'special-al-dev.yunjiglobal.com',
    recPatn: 't-do-dev.yunjiglobal.com',
    ysappItemBasePath: 'ys-do-dev.yunjiglobal.com',
    itemBasePath: 'item-do-dev.yunjiglobal.com',
    scPath: 'sc-do-dev.yunjiglobal.com',
    fxzPath: 'fxz.windinsky.com',
    environment: 'dev',
    servicePath: '//t-do-dev.yunjiglobal.com/xinyunpage/',
    h5CacheList: '//static.yunjiglobal.com/qnUpload/frontend/config/h5CacheListTest.json',
    sharePath: 't-do-dev.yunjiglobal.com',
    yunjibuyerPath: 't-do-dev.yunjiglobal.com'
  }
} else if (y === 'v') { // 本地开发环境
  config = {
    ysappItemBasePath: 'ys-do-dev.yunjiglobal.com',
    linkPath: 't-do-dev.yunjiglobal.com',
    dataBasePath: 'local.yunjiweidian.org',             
    linkBasePath: 'te.yunjiglobal.com/api',
    AWSC: 'buy-al-dev.yunjiglobal.com',
    userPath: 'user-do-dev.yunjiglobal.com',
    recPatn: 't-do-dev.yunjiglobal.com',
    buyerBasePath: 'v.yunjiglobal.com/api-buyer',
    servicePath: '//t-do-dev.yunjiglobal.com/xinyunpage/',
    spePath: 'special-al-dev.yunjiglobal.com',
    environment: 'local',
    sharePath: 't-do-dev.yunjiglobal.com',
    itemBasePath: 'item-do-dev.yunjiglobal.com',
    h5CacheList: '//static.yunjiglobal.com/qnUpload/frontend/config/h5CacheListTest.json',
    scPath: 'sc-do-dev.yunjiglobal.com',
    yunjibuyerPath: 't-do-dev.yunjiglobal.com'
  }
} else if (y === 'spe-ga') { // 现网预发布环境 gamma
  config = {   
    dataBasePath: 'data.yunjiweidian.com',
    AWSC: 'buy-al-ga.yunjiglobal.com',
    userPath: 'user-ga.yunjiglobal.com',
    spePath: 'spe-ga.yunjix.com',
    recPatn: 'r-ga.yunjiglobal.com',
    scPath: 'sc-ga.yunjiglobal.com',
    fxzPath: 'fxz.audiencetargeting.com.cn',
    servicePath: '//xinyunadmin.yunjiglobal.com/xinyunpage/',
    h5CacheList: '//static.yunjiglobal.com/qnUpload/frontend/config/h5CacheList.json',
    environment: 'gama',
    sharePath: 'share.yunjiglobal.com',
    yunjibuyerPath: 't-do-dev.yunjiglobal.com'
  }
} else if (y == 'local') { // 后台开发环境
  config = {    
    dataBasePath: 'local.yunjiglobal.com',
    AWSC: 'local.yunjiglobal.com',
    userPath: 'local.yunjiglobal.com',
    recPatn: 'local.yunjiglobal.com',
    ysappItemBasePath: 'local.yunjiglobal.com',
    servicePath: '//t-do-dev.yunjiglobal.com/xinyunpage/',
    h5CacheList: '//static.yunjiglobal.com/qnUpload/frontend/config/h5CacheListTest.json',
    environment: 'local-dev'
  }
} else { // 现网环境
  config = {
    dataBasePath: 'data.yunjiweidian.com',
    AWSC: 'buy.yunjiglobal.com',
    userPath: 'user.yunjiglobal.com',
    spePath: 'spe.yunjix.com',
    recPatn: 'r.yunjiglobal.com',
    ysappItemBasePath: 'ys.yunjiglobal.com',
    itemBasePath: 'item.yunjiglobal.com',
    scPath: 'sc.yunjiglobal.com',
    fxzPath: 'fxz.programmaticbuy.cn',
    servicePath: '//xinyunadmin.yunjiglobal.com/xinyunpage/',
    h5CacheList: '//static.yunjiglobal.com/qnUpload/frontend/config/h5CacheList.json',
    environment: 'idc',
    sharePath: 'share.yunjiglobal.com',
    yunjibuyerPath: 'm.yunjiglobal.com'
  } 
}
if (!config.linkPath) config.linkPath = window.location.host 
config.initThinkingReport = 'ta.yunjiglobal.com'
window.globalConfig = config

export default config
